module.exports = __webpack_public_path__ + "static/hiddenseabig-0479561112d131f01b2ef015bb8f152d.jpg";